import { Action, Dispatch } from "redux";
import axios from "../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import * as action_types from "./constants";
import { getClientListingType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getSubcontractorListing = (payload: getClientListingType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(
        `${baseURL}getSubcontractorListing`,
        payload
      );
      dispatch({
        type: action_types.GET_SUBCONTRACTOR_LISTING,
        data: { payload: data?.data, loading: false, count: data?.count },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_SUBCONTRACTOR_LISTING,
        data: { loading: false },
      });
    }
  };
};

export const removeSubcontractListData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_SUBCONTRACTOR_LISTING,
      data: { payload: {}, loading: true },
    });
  };
};

export const getSubcontractorDetails = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(
        `${baseURL}getSubcontractorDetails/${id}`
      );
      dispatch({
        type: action_types.GET_SUBCONTRACTOR_DETAIL,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_SUBCONTRACTOR_DETAIL,
        data: { loading: false },
      });
    }
  };
};

export const removeSubDetailData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_SUBCONTRACTOR_DETAIL,
      data: { payload: {}, loading: true },
    });
  };
};

export const getCrewFormData = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const { data } = await axios.get(`${baseURL}getCrewFormData/${id}`);
    dispatch({
      type: action_types.CREW_FORM_DATA,
      data,
    });
  };
};

export const getCrewListing = (payload: getClientListingType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(`${baseURL}getCrewListing`, payload);
      dispatch({
        type: action_types.GET_CREW_LISTING,
        data: { payload: data?.data, loading: false, count: data?.count },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_CREW_LISTING,
        data: { loading: false },
      });
    }
  };
};

export const removeCrewListData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_CREW_LISTING,
      data: { payload: {}, loading: true },
    });
  };
};

export const getCrewDetails = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getCrewDetails/${id}`);
      dispatch({
        type: action_types.GET_CREW_DETAIL,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_CREW_DETAIL,
        data: { loading: false },
      });
    }
  };
};

export const removeCrewDetailData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_CREW_DETAIL,
      data: { payload: {}, loading: true },
    });
  };
};
